// ── User Management ───────────────────────────────────────────────────────────

import type {
  PlatformUser,
  CreatePlatformUserInput,
  UpdateUserRolesInput,
} from '../../types/users';
import { apiRequest } from './http';

export async function listUsers(): Promise<PlatformUser[]> {
  return apiRequest<PlatformUser[]>('/users', { method: 'GET' });
}

export async function createUser(input: CreatePlatformUserInput): Promise<PlatformUser> {
  return apiRequest<PlatformUser>('/users', {
    method: 'POST',
    body: JSON.stringify(input),
  });
}

export async function updateUserRoles(
  userId: string,
  input: UpdateUserRolesInput
): Promise<PlatformUser> {
  return apiRequest<PlatformUser>(`/users/${userId}`, {
    method: 'PUT',
    body: JSON.stringify(input),
  });
}

export async function deleteUser(userId: string): Promise<void> {
  return apiRequest<void>(`/users/${userId}`, { method: 'DELETE' });
}
